import React, { useEffect, useState } from "react";
import Dropdown from "../../core/dropdown";
import { triggerActions } from "../../../constant/biz/trigger";
import _ from "lodash";
import { CustomType } from "../../../constant/biz/enums";
import { useTranslation } from "react-i18next";

const mapConfig = {
  id: "id",
  name: "text",
};

const defaultAction = () => ({
  type: 1,
  fieldKey: null,
  value: "",
  additionalValues: null,
});

const TriggerActions = ({ config }) => {
  const { t } = useTranslation();
  const [actions, setActions] = useState(_.get(config, "actions", []));
  const onChange = _.get(config, "onChange", () => {});

  useEffect(() => {
    onChange(actions);
  }, [actions, onChange]);

  useEffect(() => {
    setActions(_.get(config, "actions", []));
  }, [config]);

  const handleAddAction = () => {
    const updated = [...actions, defaultAction()];
    setActions(updated);
  };

  const handleRemove = (index) => {
    const updated = [...actions];
    updated.splice(index, 1);
    setActions(updated);
  };

  const handleDropdownSelect = (index, selected) => {
    const fieldKey = selected?.id || null;
    const actionType = _.get(
      _.find(triggerActions, { id: fieldKey }),
      "act_type",
      1
    );

    const updated = [...actions];
    updated[index] = {
      ...updated[index],
      fieldKey,
      type: actionType,
    };
    setActions(updated);
  };

  const handleBodyChange = (index, e) => {
    const updated = [...actions];
    const action = updated[index];

    updated[index] = {
      ...action,
      value: e.target.value,
    };
    setActions(updated);
  };

  const handleSubjectChange = (index, e) => {
    const updated = [...actions];
    const action = updated[index];

    updated[index] = {
      ...action,
      subject: e.target.value,
    };

    setActions(updated);
  };

  const handleInsertTemplate = (index, template) => {
    const updated = [...actions];
    const action = updated[index];
    const value = _.get(action, "value", "");

    updated[index] = {
      ...action,
      value: value + ` ${template}`,
    };

    setActions(updated);
  };

  return (
    <div>
      {actions.map((action, index) => {
        const fieldKey = _.get(action, "fieldKey");
        const subjectValue = _.get(action, "subject", "");
        const value = _.get(action, "value", "");
        const actionOption = _.find(triggerActions, { id: fieldKey });
        const subject = _.get(actionOption, "fields.subject", null);
        const body = _.get(actionOption, "fields.body", null);

        return (
          <div
            key={action._id || index}
            className="conditions-wraper conditions-wraper-action"
          >
            <div className="conditions-item border mt-5 p-3 rounded-2 position-relative">
              <span
                className="rounded-5 btn btn-gray"
                style={{
                  position: "absolute",
                  top: "-17px",
                  left: "1rem",
                }}
              >
                {t("settings.profile.profile_trigger.actions")} {index + 1}
              </span>
              <button
                className="conditions-remove rounded-5 btn btn-gray bg-white btn-gray-light"
                onClick={() => handleRemove(index)}
              >
                <span className="fs-5 lh-1 me-2">×</span> {t("common.remove")}
              </button>

              <div className="conditions-box d-flex flex-column gap-3 align-items-start mt-4">
                <div className="d-flex gap-2 w-100">
                  <Dropdown
                    config={{
                      options: triggerActions,
                      map: mapConfig,
                      value: action.fieldKey,
                      onSelect: (opt) => handleDropdownSelect(index, opt),
                      placeholder: "Action",
                    }}
                  />
                </div>
                {subject && subject.type === CustomType.text && (
                  <div
                    style={{
                      borderBottom: "1px solid #333",
                      width: "100%",
                    }}
                  >
                    <h6>Subject</h6>
                    <input
                      className="textarea-requester form-control border-0 rounded-0 shadow-none"
                      value={subjectValue || ""}
                      onChange={(e) => handleSubjectChange(index, e)}
                    />
                  </div>
                )}
                {body && body.type === CustomType.textarea && (
                  <textarea
                    rows="3"
                    className="textarea-requester form-control border-0 rounded-0 shadow-none"
                    value={value || ""}
                    onChange={(e) => handleBodyChange(index, e)}
                  />
                )}
              </div>

              <div className="conditions-footer bg-gray-light mt-3 p-2 px-3">
                <div className="d-flex flex-wrap gap-3 align-items-center">
                  @<span className="color-gray">|</span>
                  <button
                      className="btn btn-primary small py-1 btn-requester"
                      data-name={`{{staff.name}}`}
                      type="button"
                      onClick={() =>
                        handleInsertTemplate(index, `{{staff.name}}`)
                      }
                    >
                      Staff name
                    </button>
                  {["name", "email", "phone"].map((item) => (
                    <button
                      key={item}
                      className="btn btn-primary small py-1 btn-requester"
                      data-name={`{{requester.${item}}}`}
                      type="button"
                      onClick={() =>
                        handleInsertTemplate(index, `{{requester.${item}}}`)
                      }
                    >
                      Requester {item}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        );
      })}

      <button
        className="performs-add-item mt-3 btn btn-gray btn-outline-gray"
        onClick={handleAddAction}
      >
        <i className="fa fa-plus"></i>{" "}
        {t("settings.profile.profile_trigger.add_action")}
      </button>
    </div>
  );
};

export default TriggerActions;
